//Importaciones
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BoardAppContext from '../../../../BoardAppContext';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import { useGetUserPropsKpi } from '../../../../hooks/services/sPrivilege/useOfPrivilege';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilter from '../../../../components/Products/sKPI/Board/CalendarFilter';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric } from '../useOfBoard';
import { TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { css } from '@uifabric/experiments/lib/Utilities';
import { Card, Col, Row } from 'react-bootstrap';
import BoardComponentContent from '../ComponentManager/BoardComponentContent';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import Loading from '../../../../components/Templates/Site/Loading';
import CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';


function Board(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);

    const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);

    const ResponsiveGridLayout = WidthProvider(Responsive);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.PORTFOLIO;
    const hasPageElementId = false;
    
    const [layoutMode, setLayoutMode] = useState('normal');
    const [boardStructureGeneric, setBoardStructureGeneric] = useState(null)


    const getComponentInfoIdByContainerTitle = (data, titleToFind) => {
        const containers = data
            .flatMap(board => board.l_structure ?? [])
            .flatMap(structure => structure.l_container ?? []);

        const container = containers.find(container => {
            try {
            const htmlContainer = JSON.parse(container.htmlContainer ?? "{}");
            return htmlContainer.title === titleToFind;
            } catch {
            return false;
            }
        });

        return container?.l_components_info?.[0]?.id ?? null;
    };

    const boardStructureGenericMaximizedChartSegment = [
        {"title": "CONSOLIDATE_GROUP_CONSOLIDATE_CHART","i": "4","x": 0,"y": 4,"w": 36,"h": 12,
            l_components_info: [{
                boardElementId: null,
                boardId: -1,
                componentTypeId: 59,
                containerId: -1,
                elementId: null,
                htmlBoardAnexoRef: null,
                htmlId: null,
                htmlOnclick: null,
                htmlStyle: "CONSOLIDATE_GROUP_CONSOLIDATE_CHART",
                htmlTitle: null,
                id: !isNullUndefined(boardStructureGeneric) ? getComponentInfoIdByContainerTitle(boardStructureGeneric, 'CONSOLIDATE_GROUP_CONSOLIDATE_CHART') : -1
            }]
        },
        {"title": "CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE","i": "5","x": 0,"y": 16,"w": 36,"h": 4,
            l_components_info: [{
                boardElementId: null,
                boardId: -1,
                componentTypeId: 74,
                containerId: -2,
                elementId: null,
                htmlBoardAnexoRef: null,
                htmlId: null,
                htmlOnclick: null,
                htmlStyle: "CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE",
                htmlTitle: null,
                id: !isNullUndefined(boardStructureGeneric) ? getComponentInfoIdByContainerTitle(boardStructureGeneric, 'CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE') : -2
            }]},
    ];
    
    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(BoardTypeId, !isNullUndefinedOrEmpty(boardStructureGeneric) ? (!isNullUndefinedOrEmpty(boardStructureGeneric.boardId) ? boardStructureGeneric.boardId : (boardStructureGeneric.length > 0 ? boardStructureGeneric[0].id : 0) ) : 0, null, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 46,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    }

    useGetBoardStructureGeneric(BoardTypeId, null, boardStructureGeneric, setBoardStructureGeneric);
    useGetBoardStructureComponentsData2(boardContractFilterOfComponents, hasPageElementId, null, boardStructureGeneric, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, false);

    const maximizeSegmentosYGrafico = () => {
        setLayoutMode(layoutMode === 'normal' ? 'focus-segmentos-grafico' : 'normal');

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);
    };

    const generateContainer = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={null}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={BoardTypeId}
                                            inputParam_BoardId={boardStructureGeneric[0].id}
                                            inputParam_BoardStructure={boardStructure}
                                            inputParam_Index={index}
                                            inputParam_OnMaximize={maximizeSegmentosYGrafico}
				                            inputParam_IsMaximized={layoutMode === 'focus-segmentos-grafico'}
                                        />
                                    </div>  
                        })
                    }
                </>
    };

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                {
                    boardStructureGeneric && boardComponentInfoRecursiveFilled &&
                    <>
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                            <>
                                <CalendarFilter inputParam_BoardId={boardStructureGeneric[0].id} inputParam_ForceShowCalendar={true} inputParam_HideSettings={true} />
                                {
                                    boardStructureGeneric.map((boardStructure, indexBoardStructure) => {
                                        return <div key={indexBoardStructure}>
                                            {
                                                layoutMode === 'normal' && (!isNullUndefinedOrEmpty(boardStructureGeneric.name) ? boardStructureGeneric.name : boardStructureGeneric[0].name) === "TABLERO COMPARE" &&
                                                <CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE
                                                    inputParam_UseFake ={false}
                                                    inputParam_HideHeader={false}
                                                    inputParam_ComponentContent={null}
                                                    inputParam_BoardId={!isNullUndefined(boardStructureGeneric.boardId) ? boardStructureGeneric.boardId : boardStructureGeneric[0].id}
                                                />
                                            }
                                            {
                                                boardStructure.l_structure.length === 1 &&
                                                <ResponsiveGridLayout
                                                    measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                    breakpoints={layoutConfiguration.breakpoints}
                                                    cols={layoutConfiguration.cols}
                                                    rowHeight={layoutConfiguration.rowHeight}
                                                    isDraggable={false}
                                                    isDroppable={false}
                                                    isResizable={false}
                                                    margin={[10, 10, 10, 10]}
                                                >
                                                    {
                                                        layoutMode === 'normal' && boardStructure.l_structure[0].l_container.map((container, index) => (
                                                            <div key={index} data-grid={ __onGetDataGridHtmlContainer(container) }  className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                {generateContainer(boardStructure, container)}
                                                            </div>
                                                        ))
                                                    }
                                                    {
                                                        layoutMode === 'focus-segmentos-grafico' && boardStructureGenericMaximizedChartSegment.map((container, index) => (
                                                            <div key={index} data-grid={ container }  className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                {generateContainer(boardStructure, container)}
                                                            </div>
                                                        ))
                                                    }
                                                </ResponsiveGridLayout>
                                            }
                                            {
                                                boardStructure.l_structure.length > 1 &&
                                                boardStructure.l_structure.map((structure, index) => {
                                                    return <ResponsiveGridLayout
                                                        key={index}
                                                        breakpoints={{ lg: 1200, xs: 480 }}
                                                        cols={ { lg: 12, xs: 6 } }
                                                        rowHeight={ structure.htmlStructure.rowHeight }
                                                        margin={[10, 10, 10, 10]}
                                                    >
                                                        {
                                                            structure.l_container.map((container, index) => (
                                                                <div key={index} className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                    {generateContainer(container)}
                                                                </div>
                                                            ))
                                                        }
                                                    </ResponsiveGridLayout>
                                                })
                                            }
                                        </div>
                                    }) 
                                }
                            </>
                        }
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                            <div className="pt-5 mt-4">
                                <MessageBox  
                                    inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                            </div>
                        } 
                    </>
                }
                {
                    (!boardStructureGeneric || !boardComponentInfoRecursiveFilled) &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                } 
            </>
    );
}

export default Board;